import { z } from 'zod';

import { ForeclosureId } from '../BrandedIds';
import { Foreclosure } from '../loan/Foreclosure';
import { StopSettings } from '../loan/StopSettings';
import { zodBrandedUuid } from '../utils/Zod';
import { BaseLoanEvent } from './BaseLoanEvent';

const ForeclosureEvent = Foreclosure.pick({
  referralDate: true,
  firstLegalActionDate: true,
  lawFirm: true,
  attorneyName: true,
  attorneyPhone: true,
}).extend({
  foreclosureId: zodBrandedUuid<ForeclosureId>().optional(),
});

export const SetLoanStatusForeclosureEvent = BaseLoanEvent.extend({
  type: z.literal('setLoanStatusForeclosure'),
  ...ForeclosureEvent.shape,
  stopSettings: StopSettings.pick({
    portalPayments: true,
    emailsPaused: true,
    documentAccessPaused: true,
  }),
});
export type SetLoanStatusForeclosureEvent = z.infer<typeof SetLoanStatusForeclosureEvent>;
